import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]

import { useRenderStore } from '@/builder/stores/renderStore';
import { computed, onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorItem',
  props: {
    id: {},
    text: {},
    duration: {}
  },
  setup(__props: any) {

const props = __props;

// injects
const renderStore = useRenderStore();

// refs
const selfRemovalTimeout = ref<any>(null);
const removalTimeout = ref<any>(null);

// methods
const closeError = () => {
    // clear the self removal timeout
    if (selfRemovalTimeout.value) {
        clearTimeout(selfRemovalTimeout.value);
    }

    removalTimeout.value = setTimeout(() => {
        renderStore.clearToast(props.id);
    }, 300);
};

// computed
const id = computed(() => `errorItem_${props.id}`);

// lifecycle
onMounted(() => {
    if (props.duration) {
        selfRemovalTimeout.value = setTimeout(() => {
            closeError();
        }, props.duration);
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    id: id.value,
    class: "content error-item"
  }, [
    _createElementVNode("p", {
      class: "mb-0",
      id: id.value
    }, _toDisplayString(_ctx.text), 9, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})